import { Predicative } from '../../types'
import похуй from './похуй'

const predicatives: Array<Predicative> = [похуй]

export default predicatives
